<template>
    <div class="index_home">
        <div class="index_home_top">
            <div class="home_top_left">
                <div class="home_top_left_img">
                    <el-avatar shape="circle" :size="80" :src="userInfo.avatar
                        ? userInfo.avatar.includes('http')
                            ? userInfo.avatar
                            : IMAGE_HOST + userInfo.avatar
                        : userInfo.avatar
                        " @error="errorHandler">
                        <img :src="userInfo.sex == 1 ? useravatar_1 : useravatar_2" />
                    </el-avatar>
                </div>
                <div class="home_top_left_name">
                    <div class="home_top_left_name_top">
                        {{ getTimeState() }}{{ userInfo.nickName }}
                    </div>
                    <div class="home_top_left_name_bottom">
                        {{ getTimeStateStr() }}
                    </div>
                </div>
            </div>
            <div class="home_top_right">
                <div class="right_hospital_name">
                    {{ hospitalName() }}
                </div>
                <div class="right_address">
                    {{ deskName }}-{{ userInfo.adress }}
                </div>
            </div>
        </div>
        <div class="index_home_centent">

            <div class="index_home_carousel">
                <el-carousel indicator-position="outside" :height="imgHeight">
                    <el-carousel-item v-for="item in carousel_img_list" :key="item">
                        <img :src="item" ref="imgHeight" @load="imgLoad" class="index_home_carousel_img" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="index_home_nav">
                <div class="home_nav_item" v-if="this.l == true">
                    <div class="item_box" @click="goPage(2)">
                        <el-badge :value="messageNum" :hidden="messageNum == 0 ? true : false" class="image">
                            <img src="../../../assets/icon/homeImage/email.png" alt="" />
                        </el-badge>
                        <div class="title">消息提醒</div>
                    </div>
                </div>
                <div class="home_nav_item" v-if="this.m == true">
                    <div class="item_box" @click="goPage(11)">
                        <el-badge class="image">
                            <img src="../../../assets/icon/homeImage/addWorkOrder.png" alt="" />
                        </el-badge>
                        <div class="title">新建工单</div>
                    </div>
                </div>
                <div class="home_nav_item" v-if="this.k == true">
                    <div class="item_box" @click="goPage(10)">
                        <el-badge class="image">
                            <img class="image" src="../../../assets/icon/homeImage/workOrder.png" />
                        </el-badge>
                        <div class="title">随手记</div>
                    </div>
                </div>
                <div class="home_nav_item" v-if="this.d == true">
                    <div class="item_box" @click="goPage(4)">
                        <el-badge class="image">
                            <img class="image" src="../../../assets/icon/homeImage/CreateWork.png" />
                        </el-badge>
                        <div class="title">新建任务</div>
                    </div>
                </div>
                <div class="home_nav_item" v-if="this.a == true">
                    <div class="item_box" @click="goPage(5)">
                        <el-badge class="image">
                            <img class="image" src="../../../assets/icon/homeImage/call.png" />
                        </el-badge>
                        <div class="title">呼叫中心</div>
                    </div>
                </div>
                <div class="home_nav_item" v-if="this.e == true">
                    <div class="item_box" @click="goPage(1)">
                        <el-badge class="image">
                            <img class="image" src="../../../assets/icon/homeImage/Querywork.png" />
                        </el-badge>
                        <div class="title">查询工单</div>
                    </div>
                </div>
                <div class="home_nav_item" v-if="this.f == true">
                    <div class="item_box" @click="goPage(6)">
                        <el-badge class="image">
                            <img class="image" src="../../../assets/icon/homeImage/sentences.png" />
                        </el-badge>
                        <div class="title">服务字典</div>
                    </div>
                </div>
                <div class="home_nav_item" v-if="this.c == true">
                    <div class="item_box" @click="goPage(3)">
                        <el-badge class="image">
                            <img class="image" src="../../../assets/icon/homeImage/assetManagement.png" />
                        </el-badge>
                        <div class="title">设备管理</div>
                    </div>
                </div>
                <div class="home_nav_item" v-if="this.g == true">
                    <div class="item_box" @click="goPage(7)">
                        <el-badge class="image">
                            <img class="image" src="../../../assets/icon/homeImage/Consumables.png" />
                        </el-badge>
                        <div class="title">耗材领用</div>
                    </div>
                </div>
                <div class="home_nav_item" v-if="this.j == true">
                    <div class="item_box" @click="goPage(9)">
                        <el-badge class="image">
                            <img class="image" src="../../../assets/icon/homeImage/Department.png" />
                        </el-badge>
                        <div class="title">通讯录</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import useravatar_1 from "../../../assets/img/useravatar_1.png";
import useravatar_2 from "../../../assets/img/useravatar_2.png";
import { IMAGE_HOST } from "@/../config";
import WorkOrderEdit from "./workOrderEdit.vue";
import Task from "../../sysTask/edit.vue";
import carousel_1 from '../../../assets/carousel_img/carousel_1.png'
import carousel_2 from '../../../assets/carousel_img/carousel_2.png'
import carousel_3 from '../../../assets/carousel_img/carousel_3.png'
import carousel_4 from '../../../assets/carousel_img/carousel_4.png'
import carousel_5 from '../../../assets/carousel_img/carousel_5.png'
import carousel_6 from '../../../assets/carousel_img/carousel_6.png'
// import carousel_7 from '../../../assets/carousel_img/carousel_7.jpg'
// import carousel_8 from '../../../assets/carousel_img/carousel_8.png'
// import carousel_9 from '../../../assets/carousel_img/carousel_9.png'

export default {
    components: { WorkOrderEdit, Task },
    data() {
        return {
            IMAGE_HOST: IMAGE_HOST,
            useravatar_1: useravatar_1,
            useravatar_2: useravatar_2,
            userInfo: {},
            deskName: "",
            carousel_img_list: [
                carousel_1,
                carousel_2,
                carousel_3,
                carousel_4,
                carousel_5,
                carousel_6,
            ],
            imgHeight: '',
            teackList: {},
            deskList: [],
            workList: [],
            messageNum: 0,
            a: "",
            b: "",
            c: "",
            d: "",
            e: "",
            f: "",
            g: "",
            h: "",
            j: "",
            k: "",
            l: "",
            m: "",
        }
    },
    created() {
        this.loadUserInfo();
        this.QuickEntry();
        this.loadWorkCommon();
        this.loadTypeData();
        this.getMessageNum();
    },
    mounted() {
        this.imgLoad()
        window.onresize = () => {
            this.imgLoad()
        }

    },
    methods: {
        async getMessageNum() {
            let res = await $utils.api.load(`/admin/system/information/count`, {}, "GET");
            if (res.code == 200) {
                this.messageNum = res.data;
            }
        },
        async loadUserInfo() {
            let userId = $utils.data.get("auth", "uid");
            let res = await $utils.api.load(`/admin/system/user/get/${userId}`)
            console.log(res);
            if (res.code == 200) {
                this.userInfo = res.data
                if (this.userInfo.deskId) {
                    this.getUserDeskName()
                }
            }
        },
        async getUserDeskName() {
            let q = {}
            let res = await $utils.api.load(`/admin/system/desk/${this.userInfo.deskId}`)
            console.log(res);
            if (res.code == 200) {
                this.deskName = res.data.deskName
            }

        },
        hospitalName() {
            return $utils.data.get("customer", "Name") || "";
        },
        QuickEntry() {
            let arr = $utils.data.get("auth", "auths");
            this.a = arr.some(function (item) {
                if (item.url == "system/callcenter/index") {
                    return true; //返回false
                }
            });
            this.b = arr.some(function (item) {
                if (item.url == "system/inspection/index") {
                    return true; //返回false
                }
            });
            this.c = arr.some(function (item) {
                if (item.url == "system/device/index") {
                    return true; //返回false
                }
            });
            this.d = arr.some(function (item) {
                if (item.url == "system/sysTask/index") {
                    return true; //返回false
                }
            });
            this.e = arr.some(function (item) {
                if (item.url == "system/workOrder/index") {
                    return true; //返回false
                }
            });
            this.f = arr.some(function (item) {
                if (item.url == "system/commondescr/index") {
                    return true; //返回false
                }
            });
            this.g = arr.some(function (item) {
                if (item.url == "system/consumablesrecord/index") {
                    return true; //返回false
                }
            });
            this.h = arr.some(function (item) {
                if (item.url == "/admin/hospitalbackstage/list") {
                    return true; //返回false
                }
            });
            this.j = arr.some(function (item) {
                if (item.url == "system/offices/index") {
                    return true; //返回false
                }
            });
            this.k = arr.some(function (item) {
                if (item.url == "system/workOrder/index") {
                    return true; //返回false
                }
            });
            this.l = arr.some(function (item) {
                return true; //返回false
            })
            this.m = arr.some(function (item) {
                if (item.url == "system/simple/index") {
                    return true; //返回false
                }
            })
        },
        goPage(val) {
            if (val == 1) {
                $utils.url.push({
                    name: "processing_list",
                });
            } else if (val == 2) {
                $utils.url.push({
                    name: "messageNotification_list",
                });
            } else if (val == 3) {
                $utils.url.push({
                    name: "deviceretrieval_list",
                });
            } else if (val == 4) {
                /*   $utils.url.push({
                  name: "Edit_Task",
                }); */
                this.$Modal.success({
                    title: "新建任务",
                    closable: true,
                    width: "1000px",
                    okText: "取消",
                    showOk: false,
                    action: "add",
                    render: () => {
                        return <Task></Task>;
                    },
                });
            } else if (val == 5) {
                $utils.url.push({
                    name: "callcenter_list",
                });
            } else if (val == 6) {
                $utils.url.push({
                    name: "serveKnowledgeBase",
                });
            } else if (val == 7) {
                $utils.url.push({
                    name: "record_list",
                });
            } else if (val == 8) {
                $utils.url.push({
                    name: "hospitalbackstage",
                });
            } else if (val == 9) {
                $utils.url.push({
                    name: "contacts_list",
                });
            } else if (val == 10) {
                // $utils.url.push({
                //   name: "workOrder_add",
                // });
                this.$Modal.success({
                    title: "记录工单",
                    closable: true,
                    width: "1000px",
                    okText: "取消",
                    showOk: false,
                    render: () => {
                        return (
                            <WorkOrderEdit
                                type="jilu"
                                teackList={this.teackList}
                                workList={this.workList}
                            ></WorkOrderEdit>
                        );
                    },
                });
            } else if (val == 11) {
                $utils.url.push({
                    name: "simple",
                });
            }
        },
        getTimeState() {
            // var user = '神秘剑客漫步云端'
            // 获取当前时间
            let timeNow = new Date();
            // 获取当前小时
            let hours = timeNow.getHours();
            // 设置默认文字
            let state = ``;
            // 判断当前时间段
            if (hours >= 0 && hours <= 11) {
                state = `上午好，`;
            } else if (hours > 11 && hours <= 13) {
                state = `中午好，`;
            } else if (hours > 13 && hours <= 18) {
                state = `下午好，`;
            } else if (hours > 18 && hours <= 24) {
                state = `晚上好，`;
            }
            return state;
        },
        getTimeStateStr() {
            // var user = '神秘剑客漫步云端'
            // 获取当前时间
            let timeNow = new Date();
            // 获取当前小时
            let hours = timeNow.getHours();
            // 设置默认文字
            let state = ``;
            // 判断当前时间段
            if (hours >= 0 && hours <= 11) {
                state = `今天又是元气满满的一天！`;
            } else if (hours > 11 && hours <= 13) {
                state = `记得吃午饭哦~`;
            } else if (hours > 13 && hours <= 18) {
                state = `合理工作，注意休息哦~`;
            } else if (hours > 18 && hours <= 24) {
                state = `早点休息哦~`;
            }
            return state;
        },
        async loadWorkCommon() {
            // 通过pk查询字典数据
            let q = {};
            q.workType = 3;
            let res = await $utils.api.load("/admin/system/common/mainList", q, "get");
            if (res && res.rows) {
                this.teackList = res.rows;
            }
        },
        //选择故障类型下拉框
        async loadTypeData() {
            let q = {};
            // q.typeId = this.typeId;
            // 通过pk查询字典数据
            let res = await $utils.api.load("/admin/system/workType/listFrame", q);
            if (res && res.rows) {
                let list = res.rows;
                if (list.length > 0) {
                    let lists = [];
                    list.forEach((obj) => {
                        lists.push({ name: obj.name, typeId: obj.id });
                        if (obj.deskList && obj.deskList.length > 0) {
                            obj.deskList.forEach((item) => {
                                const newObj = {
                                    name: `${obj.name}-${item.name}`,
                                    typeId: item.id,
                                };
                                lists.push(newObj);
                            });
                        }
                    });
                    this.workList = lists;
                }
            }
        },
        errorHandler() {
            return true;
        },
        imgLoad() {
            // 获取图片高度
            this.$nextTick(() => {
                this.imgHeight = this.$refs.imgHeight['0'].height + 'px'
            })
        },

    }
}
</script>

<style lang="less" scoped>
.index_home {
    padding: 20px 40px;
    box-sizing: border-box;
    width: 100%;

    .index_home_top {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .home_top_left {
            display: flex;
            align-items: center;

            .home_top_left_img {
                margin-right: 20px;
                width: 80px;
                height: 80px;
            }

            .home_top_left_name {
                .home_top_left_name_top {
                    font-size: 20px;
                    font-weight: 800;
                    margin-bottom: 10px;
                    color: #000;
                }

                .home_top_left_name_bottom {
                    font-size: 16px;
                }
            }
        }

        .home_top_right {
            .right_hospital_name {
                font-size: 20px;
                font-weight: 800;
                margin-bottom: 10px;
                color: #000;
                text-align: right;
            }

            .right_address {
                font-size: 16px;
                text-align: right;
            }
        }
    }

    .index_home_centent {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    .index_home_nav {
        flex: 0 0 48%;
        display: flex;
        // justify-content: space-around;
        flex-wrap: wrap;
        // margin-bottom: 20px;
        padding: 16px 0;
        box-sizing: border-box;
        // margin-top: 20px;
        align-content: flex-start;

        .home_nav_item {
            cursor: pointer;
            display: flex;
            flex-direction: column;
            // align-items: center;
            // justify-content: center;
            font-size: 18px;
            flex: 0 0 25%;
            box-sizing: border-box;
            margin-bottom: 20px;
            align-items: flex-start;
            // margin-bottom: 40px;

            .item_box {
                width: 80%;
                box-shadow: 0px 0px 9px 5px #eee;
                padding: 20px 0;
                border-radius: 10px;
                margin: 0 10px;
                text-align: center;

                .title {
                    font-size: 12px;
                }

            }

            img {
                width: 100%;
                margin-bottom: 20px;
            }
        }
    }

    .index_home_carousel {
        flex: 0 0 48%;
        padding: 16px 0;

        .index_home_carousel_img {
            width: 100%;
        }
    }
}
</style>